<template>
    <div>
      <sidebar></sidebar>
      <div class="page-container">
        <div class="header">
          <a href="#"
             class="toggle-sidebar d-lg-none pg pg-menu"
             data-toggle="sidebar"
             @click="SET_SIDEBAR_OPEN(!getSidebarOpen)">
          </a>
          <div>
            <div class="brand inline">
              <img :src="require('@/assets/img/2424-logo-icon.svg')" alt="logo" width="40">
            </div>
          </div>
        </div>
        <div class="page-content-wrapper">
        <transition name="slideleft" mode="out-in" appear>
          <router-view :key="$route.fullPath"></router-view>
        </transition>
        <footer-section></footer-section>
        </div>
      </div>
    </div>
</template>

<script>
  import { mapGetters } from 'vuex'
  import { mapMutations } from 'vuex'
  import FooterSection from './components/utilities/FooterSection.vue'
  import Sidebar from './components/utilities/Navbar.vue'

  export default {
    components: {FooterSection, Sidebar},
    computed: {
      ...mapGetters([
        'getSidebarOpen',
      ]),
    },
    methods: {
      ...mapMutations([
        'SET_SIDEBAR_OPEN',
      ]),
    },
    data () {
      return {
        windowBrakeSize: 1200,
        windowSize: 0,
      }
    },
    watch: {
      windowSize(newSize) {
        if (newSize >= this.windowBrakeSize) {
          document.body.classList.add('menu-pin')
          document.body.classList.remove('menu-unpinned')
        } else {
          document.body.classList.add('menu-unpinned')
          document.body.classList.remove('menu-pin')
        }
      }
    },
    created () {
      document.body.classList.add('fixed-header')
      document.body.classList.add('windows','desktop')
      if (window.innerWidth >= this.windowBrakeSize) {
        document.body.classList.add('menu-pin')
      } else {
        document.body.classList.add('menu-unpinned')
      }
      this.$nextTick(() => {
        window.addEventListener('resize', () => {
          this.windowSize = window.innerWidth
        })
      })
    }
  }
</script>

<style>
    .icon-big {
      transform: scale(2.0);
    }

    .form-control-not-valid {
      border-bottom-color: red;
    }

    .menu-slide {
      transform: translate(210px,0);
    }

    .slideleft-enter-active, .slideleft-leave-active,
    .slideright-enter-active, .slideright-leave-active {
        transition: opacity 500ms, transform 500ms;
    }

    .slideleft-enter {
        opacity: 0;
        transform: translateX(30%);
    }

    .slideleft-leave-to {
        opacity: 0;
        transform: translateX(-30%);
    }

    .slideright-enter {
        opacity: 0;
        transform: translateX(-30%);
    }

    .slideright-leave-to {
        opacity: 0;
        transform: translateX(30%);
    }
</style>



// WEBPACK FOOTER //
// src/App.vue